import moment from 'moment';

const IncidentListColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    width: 100
  },
  {
    title: 'Webpage Name',
    dataIndex: 'webpageName',
    slot: 'webpageName',
    width: 250
  },
  {
    title: 'Webpage URL',
    dataIndex: 'webpageUrl',
    slot: 'webpageUrl',
    width: 250
  },
  {
    title: 'Detected',
    dataIndex: 'detectedAt',
    slot: 'detectedAt',
    width: 200,
    sorter: (a, b) => moment(a.detectedAt).diff(moment(b.detectedAt)),
  },
  {
    title: 'HTTP Status',
    dataIndex: 'httpStatusLabel',
    slot: 'httpStatus',
    width: 170
  },
  {
    title: 'Severity',
    dataIndex: 'severity',
    slot: 'severity',
    width: 200,
    sorter: (a, b) => {
      const severityOrder = { high: 1, medium: 2, low: 3, 'n/a': 4 };
      const severityA = severityOrder[a.severity?.toLowerCase()] || 5; // Default priority for unknown values
      const severityB = severityOrder[b.severity?.toLowerCase()] || 5;
      return severityA - severityB;
    },

  },
  {
    title: 'Grouped',
    dataIndex: 'aggregation',
    slot: 'aggregation',
    width: 220
  },
  {
    title: 'Tags',
    dataIndex: 'tags',
    slot: 'tags',
    width: 250
  },
  {
    title: 'Alert ID',
    dataIndex: 'id',
    slot: 'incidentId',
    width: 200,
    sorter: (a, b) => a.id - b.id
  },
  {
    title: '',
    dataIndex: '',
    width: 50,
    slot: 'operation'
  }
];

export { IncidentListColumn };
